import React, { useState, useEffect } from 'react';
import { X, Save, TrendingUp, Trash2, ListChecks, CheckCircle2 } from 'lucide-react';
import { ref, update, onValue, push, remove, query, orderByChild } from "firebase/database";
import { db } from "../firebase";
import './TradingControlModal.css';

const TradingControlModal = ({ user, onClose }) => {
  const [amount, setAmount] = useState('');
  const [type, setType] = useState('profit');
  const [activeTrades, setActiveTrades] = useState([]);

  useEffect(() => {
    // Humne query use ki hai taake trades timestamp ke hisab se order hon
    const tradesRef = query(ref(db, `tradingControl/${user.dbKey}/queues`), orderByChild('timestamp'));
    
    const unsubscribe = onValue(tradesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ 
          id: key, 
          ...data[key] 
        }));
        // Purani trades upar, new niche (First In, First Out logic)
        setActiveTrades(list.sort((a, b) => a.timestamp - b.timestamp));
      } else {
        setActiveTrades([]);
      }
    });
    return () => unsubscribe();
  }, [user.dbKey]);

  const handleSaveTrade = async () => {
    if (!amount || parseFloat(amount) <= 0) return alert("Enter amount");
    try {
      const tradesRef = ref(db, `tradingControl/${user.dbKey}/queues`);
      const finalPnL = type === 'loss' ? -Math.abs(parseFloat(amount)) : Math.abs(parseFloat(amount));
      
      await push(tradesRef, {
        pnl: finalPnL,
        type: type,
        isCompleted: false, 
        timestamp: Date.now() // Ye timestamp queueing ke liye zaroori hai
      });

      setAmount('');
    } catch (e) { console.error(e); }
  };

  const deleteTrade = async (id) => {
    await remove(ref(db, `tradingControl/${user.dbKey}/queues/${id}`));
  };

  return (
    <div className="modal-overlay">
      <div className="trade-control-modal wide-layout animated-fade-in">
        <div className="modal-header-main">
          <div className="header-left">
            <TrendingUp size={22} color="#f0b90b" />
            <h3>Trade Manager: {user.username}</h3>
          </div>
          <X onClick={onClose} className="close-ptr" />
        </div>
        
        <div className="modal-content-split">
          <div className="input-section-left">
            <div className="control-group">
              <label>Result Type</label>
              <div className="type-toggle">
                <button className={`toggle-btn profit ${type === 'profit' ? 'active' : ''}`} onClick={() => setType('profit')}>PROFIT</button>
                <button className={`toggle-btn loss ${type === 'loss' ? 'active' : ''}`} onClick={() => setType('loss')}>LOSS</button>
              </div>
            </div>

            <div className="control-group">
              <label>Amount (USDT)</label>
              <div className="premium-input-box">
                <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="0.00" />
              </div>
            </div>

            <button className="main-save-btn" onClick={handleSaveTrade}><Save size={18} /> Save Next Trade</button>
          </div>

          <div className="queue-section-right">
            <div className="queue-header">
              <ListChecks size={18} />
              <h4>PENDING QUEUE ({activeTrades.filter(t => !t.isCompleted).length})</h4>
            </div>
            
            <div className="trades-scroll-area">
              {activeTrades.length === 0 ? (
                <p className="no-trades">No pending trades</p>
              ) : (
                activeTrades.map((trade) => (
                  <div key={trade.id} className={`queue-card ${trade.type} ${trade.isCompleted ? 'completed' : ''}`}>
                    <div className="q-info">
                      <span className="q-pnl">{trade.pnl > 0 ? '+' : ''}{trade.pnl} USDT</span>
                    </div>
                    <div className="q-actions">
                      {trade.isCompleted ? (
                        <CheckCircle2 size={18} className="done-tick" />
                      ) : (
                        <Trash2 size={16} className="del-btn-queue" onClick={() => deleteTrade(trade.id)} />
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingControlModal;